export enum FbaDeliveryDetailsActionTypes {
  SET_DELIVERY_ADDRESS = "SET_DELIVERY_ADDRESS",
  SET_SUPPORTED_FIELDS = "SET_SUPPORTED_FIELDS",
  SET_AMAZON_SHIPMENT_ID = "SET_AMAZON_SHIPMENT_ID",
  SET_AMAZON_REFERENCE_ID = "SET_AMAZON_REFERENCE_ID",
}
